// Animation timing constants in milliseconds
export const ANIMATION_TIMING = {
  TRANSITION_DURATION: 200,
  ICON_ANIMATION_DURATION: 300,
  SQUARE_ANIMATION_DURATION: 300, // Spring expansion duration
  TRANSITION_OVERLAY_FLY_DURATION: 350, // Icon fly animation + buffer
  ELEMENTS_DELAY: 600,
  ELEMENTS_DURATION: 400,
  CONTENT_DELAY_OFFSET: 100, // Added to ELEMENTS_DELAY for subheading
  DELAYED_CONTENT_DELAY: 1400,
}

// Animation physics config
export const SPRING_CONFIG = {
  STIFF: { tension: 280, friction: 24 },
  GENTLE: { tension: 120, friction: 14 },
}

// Layout constants (in pixels)
export const LAYOUT = {
  TARGET_Y_OFFSET: 0, // Vertical offset from top for splash icon
  ESTIMATED_HEADER_HEIGHT: 64, // Global header + banner height
  SQUARE_PADDING: 30, // Padding around background square
  CONTENT_Y_OFFSET: 20, // Vertical offset for content animations
}
